import Vue from "vue"
import App from "./App"
import VueMaterial from "vue-material"
import store from "./store"
import router from "./router"
import { ApolloClient } from "apollo-client"
import { HttpLink } from "apollo-link-http"
import { setContext } from "apollo-link-context"
import { InMemoryCache } from "apollo-cache-inmemory"
import VueApollo from "vue-apollo"
import "vue-material/dist/vue-material.min.css"
import "vue-material/dist/theme/default-dark.css"

Vue.config.productionTip = false
Vue.use(VueMaterial)
Vue.use(VueApollo)

const httpLink = new HttpLink({
  uri: "https://us-central1-quicktourney-785b5.cloudfunctions.net/api/graphql"
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  //const cu = localStorage.getItem(CURRENT_USER_KEY)
  const cu = store.state.currentUser
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: cu && cu.token ? `Bearer ${cu.token}` : ""
    }
  }
})

// Create the apollo client
const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  connectToDevTools: true
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

new Vue({
  el: "#app",
  router,
  apolloProvider,
  template: "<App/>",
  components: { App },
  store
})



// WEBPACK FOOTER //
// ./src/main.js